export default __webpack_public_path__ + "static/cardImg3-f33c290bc581142e4d0049360b97bed0.webp";